import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["startInput", "endInput"];
  
  static values = {
    filterParam: String
  };
  
  static outlets = ["filters"];

  connect() {
    // Initialize controller
    this.filterParam = this.element.dataset.dateFilterFilterParam || 'date';
    
    // Load values from URL params
    this.loadFromUrlParams();
  }
  
  /**
   * Load date values from URL parameters
   * This ensures the date inputs reflect any filter values in the URL
   */
  loadFromUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const startParamName = `${this.filterParam}_start`;
    const endParamName = `${this.filterParam}_end`;
    
    const startDate = params.get(startParamName);
    const endDate = params.get(endParamName);
    
    if (startDate) {
      this.startInputTarget.value = startDate;
    }
    
    if (endDate) {
      this.endInputTarget.value = endDate;
    }
    
    if (startDate || endDate) {
      this.updateFilter(true);
    }
  }
  
  /**
   * Handle date input changes
   * @param {Event} event - The change event
   */
  handleInputChange(event) {
    this.updateFilter();
  }
  
  /**
   * Update filter with current date values
   * Sends the current date values to the filters controller
   * @param {boolean} initializing - Whether this update is part of initialization
   */
  updateFilter(initializing = false) {
    const startValue = this.startInputTarget.value.trim();
    const endValue = this.endInputTarget.value.trim();
    
    this.filtersOutlet.updateDateFilter(this.filterParam, startValue, endValue, initializing);
  }
  
  /**
   * Clear the date filter and reset to empty values
   */
  clear() {
    // Clear input values
    this.startInputTarget.value = '';
    this.endInputTarget.value = '';
    
    // Update filter
    this.updateFilter();
  }
}
